export default {
    hackathons: [],
    hackathon: {},
    comments: [],
    demo: {},
};
